// extracted by mini-css-extract-plugin
module.exports = {"Container":"SuccessScreen_Container__3GRhA","Countdown":"SuccessScreen_Countdown__3oK37"};